export function buildUserSelectionState(nextUser, previousUser = {}, botNumber = '') {
  const nextSelection = Date.now() + Math.random();

  return {
    ...nextUser,
    bot_number: botNumber,
    not_read_count: 0,
    selection_key: nextSelection,
  };
}
